<template>
    <div id="search-box">
      <div class="inner_static">
        <a class="btn_close" @click="btnCloseClick()"></a>
        <div class="inner_box">
          <div class="control">
            <div class="keyword">
              <input type="text" id="keyword" name="keyword" placeholder="Keyword" class="input_keyword" v-model="keywordText"><a class="btn_keyword" @click="btnSearchClick()"></a>
            </div>
            <ul class="order">
              <li :class="{active: isNewArrival}">
                <a @click="changeSortOrder(true)">新着順</a>
              </li>
              <li :class="{active: !isNewArrival}">
                <a @click="changeSortOrder(false)">人気順</a>
              </li>
            </ul>
          </div>
          <div class="category">
            <ul class="lst_category">
              <li class="cateA">
                <a id="category_open" @click="btnCategorySearchCate()">カテゴリーを選択する</a>
                <transition
                  name="toggle-slide"
                  @before-enter="beforeEnter"
                  @enter="enter"
                  @before-leave="beforeLeave"
                  @leave="leave"
                >
                  <ul class="select_ul" v-show="categoryIsActive">
                    <li v-for="(category, index) in categoryList" :key="index">
                      <a :style="{backgroundImage: 'url(' + getIconImg(category.categoryIcon) + ')'}"
                        :class="{activeColor: selectedCategoryId === category.categoryId, deselectColor: selectedCategoryId !== category.categoryId}"
                        @click="selectCategory(category)">
                        {{category.categoryName}}
                      </a>
                    </li>
                  </ul>
                </transition>
              </li>
              <li class="cateB">
                <a id="style_open" @click="btnStyleSearchCate()">スタイルから絞り込む</a>
                <transition
                  name="toggle-slide"
                  @before-enter="beforeEnter"
                  @enter="enter"
                  @before-leave="beforeLeave"
                  @leave="leave"
                >
                  <ul class="select_ul" v-show="styleIsActive">
                    <li v-for="(style, index) in styleList" :key="index">
                      <a v-if="selectedCategoryId === style.categoryId"
                        :style="{backgroundImage: 'url(' + getIconImg(style.styleIcon) + ')'}"
                        :class="{activeColor: selectedStyleId === style.styleId, deselectColor: selectedStyleId !== style.styleId}"
                        @click="selectStyle(style)">
                        {{style.styleName}}
                      </a>
                    </li>
                  </ul>
                </transition>
              </li>
              <!-- TODO 一旦閉じる
              <li class="cateC">
                <a id="shape_open" @click="btnShapeSearchCate()">シェイプから絞り込む</a>
                <transition
                  name="toggle-slide"
                  @before-enter="beforeEnter"
                  @enter="enter"
                  @before-leave="beforeLeave"
                  @leave="leave"
                >
                  <ul class="select_ul" v-show="shapeIsActive">
                    <li v-for="(item, index) in shapes" :key="index">
                      <a :style="{backgroundImage: 'url(' + getIconImg(item.img) + ')'}"
                        :class="{activeColor: selectedShapeId === item.id, deselectColor: selectedShapeId !== item.id}" @click="selectShape(item)">
                        {{item.name}}
                      </a>
                    </li>
                  </ul>
                </transition>
              </li>
              -->
            </ul>
          </div>
          <div class="btn_area">
            <a class="btn_search" @click="btnSearchClick()">Search</a>
          </div>
        </div>
      </div>
      <!-- ローディングモーダル -->
      <kg-loading-modal ref="loadingModalRef" />
    </div>
</template>

<script>
import axios from 'axios'
import {KG_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import LoadingModal from '../../../components/common/LoadingModal'

export default {
  components: {
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      keywordText: '',
      categoryIsActive: false,
      styleIsActive: false,
      shapeIsActive: false,
      isNewArrival: true,
      selectedCategoryId: -1,
      selectedStyleId: -1,
      selectedShapeId: -1
    }
  },
  props: {
    categoryList: Array,
    styleList: Array,
    shapes: Array
  },
  methods: {
    selectCategory: function (item) {
      // カテゴリー選択時の処理
      this.selectedCategoryId = item.categoryId
    },
    selectStyle: function (item) {
      // スタイル選択時の処理
      this.selectedStyleId = item.styleId
    },
    selectShape: function (item) {
      // スタイル選択時の処理
      this.selectedShapeId = item.id
    },
    btnSearchClick: function () {
      // 検索ボタン押下時の処理
      if (this.selectedCategoryId === -1) {
        App.showModal({
          title: '',
          messages: [' カテゴリーを設定してください。']
        })
        return
      }
      // 検索ボックスを閉じる
      if (this.isOpen) this.btnCloseClick(null)
      // 親コンポーネントのイベント実行,選択されたカテゴリーIDをトップ画面のスライドに反映させる
      this.$emit('setSlideEvent', this.selectedCategoryId)
    },
    search: function () {
      // 検索処理
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          keywords: this.keywordText,
          categoryId: this.unselectedToNull(this.selectedCategoryId),
          styleId: this.unselectedToNull(this.selectedStyleId),
          shapeId: this.unselectedToNull(this.selectedShapeId)
        }
      }
      axios.get(KG_URL.TOP + '/search', payload)
        .then(response => {
          if (response.data.errorMessage) {
            // TODO 未実装
          } else {
            let resultList = []
            if (response.data.data) {
              response.data.data
                .forEach(e => {
                  let kgFdImage = e.contentsDataModelList != null && e.contentsDataModelList.length > 0
                    ? e.contentsDataModelList[0].corpId + '/' + e.contentsDataModelList[0].contentsImgMid
                    : null
                  let plan = {
                    kgFdId: e.kgFdId,
                    kgFdName: e.kgFdName,
                    kgFdImage: kgFdImage
                  }
                  resultList.push(plan)
                })
            }
            // 親コンポーネントのイベント実行,取得したデータを表示させる
            this.$emit('setOpenPlanListEvent', {list: resultList, keyword: this.keywordText})

            // ファイル選択
            // if (param === undefined) {
            //   let plan = this.openPlanList[0]
            //   this.selectedPlan(plan)
            // } else {
            //   this.readingPlan(param)
            // }
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    // planClick: function (plan) {
    //   // 検索したプランを選択時の処理
    //   // 検索ボックスを閉じる
    //   this.btnCloseClick(null)
    //   // 親コンポーネントのイベント実行
    //   this.$emit('setOpenPlanEvent', plan)
    // },
    // btnMoreClick: function () {
    //   this.dispPlanCount += 3
    // },
    setSelectedCategoryId: function (categoryId) {
      this.selectedCategoryId = categoryId
    },
    unselectedToNull: function (num) {
      return num === -1 ? null : num
    },
    btnCloseClick: function (event) {
      // 検索ボックスを閉じる
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var searchBox = document.getElementById('search-box')
      var bodyElements = document.getElementsByTagName('body')
      if (searchBox.classList.contains('open')) {
        searchBox.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        searchBox.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    },
    btnCategorySearchCate: function (event) {
      // カテゴリーの選択リストの切り替え
      if (event) {
        event.preventDefault()
      }
      var target = document.getElementById('category_open')
      if (target.parentNode.classList.contains('active')) {
        target.parentNode.classList.remove('active')
      } else {
        target.parentNode.classList.add('active')
      }
      this.categoryIsActive = !this.categoryIsActive
    },
    btnStyleSearchCate: function (event) {
      // スタイルの選択リストの切り替え
      if (event) {
        event.preventDefault()
      }
      var target = document.getElementById('style_open')
      if (target.parentNode.classList.contains('active')) {
        target.parentNode.classList.remove('active')
      } else {
        target.parentNode.classList.add('active')
      }
      this.styleIsActive = !this.styleIsActive
    },
    btnShapeSearchCate: function (event) {
      // シェイプの選択リストの切り替え
      if (event) {
        event.preventDefault()
      }
      var target = document.getElementById('shape_open')
      if (target.parentNode.classList.contains('active')) {
        target.parentNode.classList.remove('active')
      } else {
        target.parentNode.classList.add('active')
      }
      this.shapeIsActive = !this.shapeIsActive
    },
    changeSortOrder: function (isNewArrival) {
      this.isNewArrival = isNewArrival
    },
    // transition hook 各リストの開閉時のtransitionに使われる
    beforeEnter (el) {
      el.style.height = '0'
    },
    enter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave (el) {
      el.style.height = '0'
    },
    getIconImg: function (icon) {
      return App.getKagullResource(icon)
    }
  },
  computed: {
    isOpen: function () {
      var searchBox = document.getElementById('search-box')
      return searchBox.classList.contains('open')
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/top/Search.vue